import "core-js/modules/es6.object.assign";
import "core-js/modules/es6.object.define-property";
import "core-js/modules/es6.symbol";
import "core-js/modules/es6.array.index-of";
import "core-js/modules/web.dom.iterable";
import "core-js/modules/es6.array.iterator";
import "core-js/modules/es6.object.to-string";
import "core-js/modules/es6.object.keys";
import "core-js/modules/es6.string.link";
import "core-js/modules/es6.string.bold";

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _defineProperty(obj, key, value) { if (key in obj) { Object.defineProperty(obj, key, { value: value, enumerable: true, configurable: true, writable: true }); } else { obj[key] = value; } return obj; }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import React from 'react';
import classNames from 'classnames';
import classes from '@nerdwallet/base-styles/classes';
import Type from '@nerdwallet/react-typography';
import { useDeprecatedPropsWarning } from '@nerdwallet/deprecate';
import styles from './legacy-link.module.less';

var inferType = function inferType(Component) {
  // Should use type=button when using a <button> component, but not needed
  // when using <a>. This can be overridden by passing a `type` prop.
  if (Component === 'button') {
    return {
      type: 'button'
    };
  }

  return {};
};
/**
 * NOTE: This component is considered deprecated. Minimal support sill be
 * provided going forward, and it will be removed in the next major version.
 * Please avoid any props that trigger this component to render.
 *
 * As of v1.7, users should only
 * use links that correlate to the size of the
 * following Typography components:
 *
 *   <Body>
 *   <Body size="small">
 *   <Legal>
 *
 * For example with the size prop,
 *
 * <Link size="small" />
 * <Link size="legal" />
 *
 * If it's not possible to compose a link within a
 * Body or Legal component, then the reflecting size map is:
 *
 * Body text: <Link size={2}>
 * Body size="small" text: <Link size={1}>
 * Legal sized text: <Link size={0}>
 *
 * Although discouraged, to maintain backwards compatibility, numbers are
 * accepted with 0 as the smallest and 5 as the biggest.
 *
 * Size is inherited if not specified. So if a Link is used within the
 * above containing components, the size prop is not needed. For example:
 *
 *  <Body size="small">
 *    <Link href="#">Click</Link>
 *  </Body>
 *
 * will render a Link of Type size 1. See @nerdwallet/react-typography
 * for more implementation details on this type scale.
 */


var validSizes = [0, 1, 2, 3, 4, 5];
var linkLevelSizeMap = {
  small: 1,
  legal: '0'
};
var LegacyLink = /*#__PURE__*/React.forwardRef(function (props, ref) {
  var _classNames, _classNames2;

  useDeprecatedPropsWarning({
    component: 'Link',
    deprecatedProps: [{
      deprecated: 'bold',
      migration: 'Designers should not be using bold in links. Slack #design-system with your use case and to get help!',
      version: '1.7.0'
    }, {
      deprecated: 'chronicle',
      migration: 'Designers should not be using Chronicle in links. Slack #design-system with your use case and to get help!',
      version: '1.7.0'
    }, {
      deprecated: 'color',
      migration: 'All links should appear as default blue. Slack #design-system with your use case and to get help!',
      version: '1.7.0'
    }, {
      deprecated: 'decorated',
      migration: 'All links should appear as default blue at this time, so underline is not needed. Slack #design-system with your use case and to get help!',
      version: '1.7.0'
    }, {
      deprecated: 'italic',
      migration: 'Designers should not be using italic in links. Slack #design-system with your use case and to get help!',
      version: '1.7.0'
    }, {
      deprecated: 'uppercase',
      migration: 'All links should appear Body, Body Small or Legal at this time. Slack #design-system with your use case and to get help!',
      version: '1.7.0'
    }, {
      deprecated: 'unstyled',
      migration: 'All links should appear as default blue. Slack #design-system with your use case and to get help!',
      version: '1.7.0'
    }],
    props: props
  });

  var bold = props.bold,
      children = props.children,
      chronicle = props.chronicle,
      className = props.className,
      color = props.color,
      component = props.component,
      disabled = props.disabled,
      decorated = props.decorated,
      gotham = props.gotham,
      href = props.href,
      italic = props.italic,
      size = props.size,
      unstyled = props.unstyled,
      uppercase = props.uppercase,
      dangerouslyForceHoverStyling = props.dangerouslyForceHoverStyling,
      dangerouslyForceFocusStyling = props.dangerouslyForceFocusStyling,
      dangerouslyForceActiveStyling = props.dangerouslyForceActiveStyling,
      otherProps = _objectWithoutProperties(props, ["bold", "children", "chronicle", "className", "color", "component", "disabled", "decorated", "gotham", "href", "italic", "size", "unstyled", "uppercase", "dangerouslyForceHoverStyling", "dangerouslyForceFocusStyling", "dangerouslyForceActiveStyling"]); // Component overrides


  var Component = component || (href ? 'a' : 'button');
  /**
   * Since v1.7, many bespoke customization props
   * have been deprecated.
   *
   * This is a helper function to isolate the deprecated styles
   * and state permutations that should no longer be used.
   */

  var deprecatedStyles = function deprecatedStyles() {
    var deprecated = [];

    if (decorated) {
      deprecated.push(styles['link-decorated']);
    }

    if (color) {
      deprecated.push(styles['link-color-override']);
      deprecated.push(classes(["color-".concat(color)]));
    }

    if (decorated && color) {
      deprecated.push(classes(["border-".concat(color)]));
    }

    return deprecated;
  };

  var shouldInheritStyles = unstyled || !(size || chronicle || gotham);
  /**
   * For default standard NerdWallet links, we render an <a> directly
   * and avoid the extra <span>, which is likely an
   * SEO improvement (see FEI-755).
   *
   * If a deprecated component prop is supplied,
   * then we maintain v1.6 behavior, which is
   * mounting an outer component (eg. a button or a)
   * composing its children within a span.
   *
   * The standard NerdWallet blue link color is defined in base.css
   * in base-styles, and will take precedence over a standalone
   * <a> element if the color is being overridden.
   */

  return /*#__PURE__*/React.createElement(Type, _extends({}, inferType(Component), {
    bold: bold,
    chronicle: chronicle,
    className: classNames((_classNames = {}, _defineProperty(_classNames, styles['type-inherit'], shouldInheritStyles), _defineProperty(_classNames, styles['button-unstyling'], Component === 'button'), _classNames), styles['link-unstyling']),
    color: color,
    component: Component // Don't render this prop to the DOM unless we're actually disabled
    ,
    disabled: disabled || undefined,
    gotham: gotham,
    href: href,
    italic: italic,
    ref: ref // Get the numeric size if a semantic
    // size prop is used (eg. "small")
    ,
    size: linkLevelSizeMap[size] || size,
    uppercase: uppercase
  }, otherProps), /*#__PURE__*/React.createElement("span", {
    className: classNames(className, styles.link, (_classNames2 = {}, _defineProperty(_classNames2, styles['link-default'], !unstyled && !color), _defineProperty(_classNames2, styles['link-decorated'], decorated), _defineProperty(_classNames2, styles['force-active'], dangerouslyForceActiveStyling), _defineProperty(_classNames2, styles['force-focus'], dangerouslyForceFocusStyling), _defineProperty(_classNames2, styles['force-hover'], dangerouslyForceHoverStyling), _classNames2), deprecatedStyles())
  }, children));
});
LegacyLink.displayName = 'LegacyLink';
LegacyLink.defaultProps = {
  bold: false,
  children: null,
  chronicle: false,
  className: null,
  color: null,
  component: null,
  decorated: false,
  disabled: false,
  href: null,
  gotham: true,
  italic: false,
  size: null,
  unstyled: false,
  uppercase: false,
  dangerouslyForceHoverStyling: false,
  dangerouslyForceFocusStyling: false,
  dangerouslyForceActiveStyling: false
};
export default LegacyLink;